<template>
	<div>
		<el-dialog title="同步订单" @close="cancel()" :visible.sync="visible" width="40%" center>
			<div class="opts_wrap" v-loading="loading">
				<div class="sync_progress_line">
					<span class="sync_label">同步进度：</span>
					<span v-if="!syncTask" class="sync_muted">暂无同步任务</span>
					<span v-else class="sync_progress_text">
						{{ syncTask.shop_name || syncTask.shop_id }}
						· {{ syncStatusText(syncTask.status) }}
						· 已同步 {{ syncTask.order_synced || 0 }}/{{ syncTask.order_found || 0 }}
						· 时间片 {{ syncTask.segment_done || 0 }}/{{ syncTask.segment_total || 0 }}
						<span v-if="syncTask.error_msg" class="sync_err">（{{ syncTask.error_msg }}）</span>
					</span>
					<el-button
						type="text"
						size="mini"
						class="sync_refresh_btn"
						:loading="refreshing"
						@click="onRefreshProgress"
					>刷新</el-button>
				</div>

				<div class="opts_line">
					<p class="txt">
						<span class="label">选择店铺：</span>
						<span class="val">
							<el-select
								size="small"
								v-model="form.shop_ids"
								placeholder="请选择"
								clearable
								multiple
								collapse-tags
								filterable
							>
								<el-option
									v-for="(item, index) in shopList"
									:key="item.shop_id || index"
									:label="item.shop_name"
									:value="item.shop_id"
								>
								</el-option>
							</el-select>
						</span>
					</p>
				</div>
				<div class="opts_line">
					<p class="txt">
						<span class="label">选择时间：</span>
						<span class="val">
							<el-date-picker
								v-model="form.add_date"
								type="datetimerange"
								align="right"
								unlink-panels
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								value-format="yyyy-MM-dd HH:mm:ss"
								:picker-options="pickerOptions"
								:default-time="['00:00:00', '23:59:59']"
							>
							</el-date-picker>
						</span>
					</p>
				</div>

				<div class="btn_wrap">
					<p class="btn" @click="bindSubmit()">同步</p>
					<p class="btn" @click="cancel()">关闭</p>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
	name: 'SyncWxOrder',
	props: {
		show: {
			type: Boolean,
			default: false,
		},
		syncTask: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			shopList: [],
			loading: false,
			refreshing: false,
			form: {
				shop_ids: [],
				add_date: [],
			},
			pickerOptions: {
				shortcuts: [
					{
						text: '最近一周',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
							picker.$emit('pick', [start, end])
						},
					},
					{
						text: '最近一个月',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
							picker.$emit('pick', [start, end])
						},
					},
					{
						text: '最近三个月',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
							picker.$emit('pick', [start, end])
						},
					},
				],
			},
		}
	},
	computed: {
		visible: {
			get() {
				return this.show
			},
			set(val) {
				if (!val) this.$emit('close')
			},
		},
	},
	watch: {
		show(val) {
			if (val) {
				this.shopList = []
				this.form = { shop_ids: [], add_date: [] }
				this.init()
				this.$emit('refresh-sync')
			}
		},
	},
	methods: {
		...mapActions('wxshopOrder', [
			'getShopListAction',
			'postOrderSyncAction',
		]),
		syncStatusText(st) {
			const map = { 0: '待处理', 1: '进行中', 2: '成功', 3: '部分失败', 4: '失败', 5: '取消' }
			return map[st] || ('状态' + st)
		},
		onRefreshProgress() {
			this.refreshing = true
			this.$emit('refresh-sync')
			setTimeout(() => {
				this.refreshing = false
			}, 400)
		},
		init() {
			this.loading = true
			this.getShopListAction({
				success: (res) => {
					this.loading = false
					if (res.code === 200) {
						this.shopList = (res.data && res.data.list) || []
						// 默认最近 15 天
						const end = new Date()
						const start = new Date()
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 15)
						const fmt = (d) => {
							const p = (n) => (n < 10 ? '0' + n : '' + n)
							return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
								+ ' ' + p(d.getHours()) + ':' + p(d.getMinutes()) + ':' + p(d.getSeconds())
						}
						this.form.add_date = [fmt(start), fmt(end)]
						if (this.shopList.length === 1) {
							this.form.shop_ids = [this.shopList[0].shop_id]
						}
					} else {
						this.$message({ message: res.msg || '加载店铺失败', type: 'error' })
						this.$emit('close')
					}
				},
				error: () => {
					this.loading = false
					this.$message.error('加载店铺失败')
					this.$emit('close')
				},
			})
		},
		bindSubmit() {
			if (this.loading) return
			if (!this.form.shop_ids || !this.form.shop_ids.length) {
				this.$message.warning('请选择店铺')
				return
			}
			if (!this.form.add_date || this.form.add_date.length < 2) {
				this.$message.warning('请选择同步时间')
				return
			}
			this.loading = true
			this.postOrderSyncAction({
				data: {
					shop_ids: this.form.shop_ids,
					add_date: this.form.add_date,
				},
				success: (res) => {
					this.loading = false
					if (res.code === 200) {
						this.$message({ message: (res.data && res.data.message) || res.msg || '同步任务已创建', type: 'success' })
						this.$emit('success', res.data || {})
						// 留在弹窗内查看同步进度，不自动关闭
						this.$emit('refresh-sync')
					} else {
						this.$message({ message: res.msg || '同步失败', type: 'error' })
					}
				},
				error: () => {
					this.loading = false
					this.$message.error('同步失败')
				},
			})
		},
		cancel() {
			this.$emit('close')
		},
	},
}
</script>

<style scoped>
.opts_wrap { padding-top: 8px; }
.sync_progress_line {
	margin-bottom: 8px;
	padding: 10px 12px;
	background: #fafafa;
	border: 1px solid #eee;
	border-radius: 4px;
	font-size: 13px;
	color: #666;
	line-height: 1.5;
}
.sync_label { color: #333; font-weight: 600; margin-right: 6px; }
.sync_muted { color: #999; }
.sync_progress_text { word-break: break-all; }
.sync_err { color: #f0413e; }
.sync_refresh_btn { margin-left: 8px; padding: 0; vertical-align: baseline; }
.opts_wrap .opts_line { margin-top: 20px; display: flex; align-items: center; }
.opts_line .txt { width: 100%; font-size: 16px; display: flex; align-items: center; }
.opts_line .txt .label { min-width: 80px; display: inline-block; }
.opts_line .txt .val { flex: 1; }
.opts_wrap .btn_wrap { margin: 40px auto 0 auto; display: flex; align-items: center; justify-content: center; }
.opts_wrap .btn_wrap .btn {
	width: 80px; height: 34px; border-radius: 4px; display: flex; justify-content: center; align-items: center;
	cursor: pointer; box-sizing: border-box; font-size: 14px;
}
.opts_wrap .btn_wrap .btn:nth-child(1) { background: var(--red, #f0413e); color: #fff; margin-right: 14px; }
.opts_wrap .btn_wrap .btn:nth-child(2) { background: #fff; color: #333; border: 1px solid #ddd; }
.opts_wrap >>> .el-date-editor { margin-top: unset; width: 100%; }
.opts_wrap >>> .el-select { width: 100%; }
</style>
